module.exports = __webpack_public_path__ + "static/media/kn.a1e5c90b.svg";